import { render, staticRenderFns } from "./OptionsComponentResponsive.vue?vue&type=template&id=5ddcf1f8&scoped=true"
import script from "./OptionsComponentResponsive.vue?vue&type=script&lang=js"
export * from "./OptionsComponentResponsive.vue?vue&type=script&lang=js"
import style0 from "./OptionsComponentResponsive.vue?vue&type=style&index=0&id=5ddcf1f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddcf1f8",
  null
  
)

export default component.exports